import React, { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Sun, Moon } from "lucide-react";

const THEMES = [
  { code: "light", icon: Sun },
  { code: "dark", icon: Moon },
];

// `compact`: opt-in, por defecto false — preserva el render actual byte a byte.
// Reduce el padding horizontal interno de los botones (10px -> 4px por lado)
// solo por debajo de `sm:` (640px) — a partir de ahí vuelve al tamaño de
// siempre, igual que el resto del header público (ver PublicHeader.jsx,
// mismo patrón que `px-3 sm:px-6`/`gap-0.5 sm:gap-3` de PR #229). Así el
// escritorio (criterio 4) queda idéntico a hoy con o sin este prop.
export default function ThemeSwitcher({ className = "", compact = false }) {
  const { resolvedTheme, setTheme } = useTheme();
  // resolvedTheme es undefined en el primer render del servidor/hidratación —
  // evita parpadeo mostrando nada hasta que next-themes resuelva el valor real.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return <div className={`h-7 ${compact ? "w-[54px] sm:w-[68px]" : "w-[68px]"} ${className}`} />;

  return (
    <div className={`inline-flex items-center rounded-full border border-brand-edge bg-card p-0.5 text-xs font-bold ${className}`} data-testid="theme-switcher">
      {THEMES.map(({ code, icon: Icon }) => (
        <button
          key={code}
          onClick={() => setTheme(code)}
          className={`flex items-center justify-center rounded-full ${compact ? "px-1 sm:px-2.5 py-1" : "px-2.5 py-1"} transition-colors ${
            resolvedTheme === code ? "bg-brand-terracotta text-white dark:text-black" : "bg-brand-stone text-white dark:text-black"
          }`}
          data-testid={`theme-switch-${code}`}
          aria-pressed={resolvedTheme === code}
          aria-label={code === "dark" ? "Tema oscuro" : "Tema claro"}
        >
          <Icon size={14} />
        </button>
      ))}
    </div>
  );
}
